const enumAgendamentoServico = Object.freeze({
  NaoPermitido: 0,
  PermitidoParaTodos: 1,
  NaoPermitidoParaClientes: 2,
});

export default enumAgendamentoServico;
